import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchSuccess,
  fetchFailure,
  singleDeleteRequestSuccess,
  singleDeleteRequestFailure,
  singleCancelRequestSuccess,
  singleCancelRequestFailure,
  downloadSuccess,
  downloadFailure,
  createSuccess,
  deviceDetailsRequest,
  createFailure,
  updateshipSuccess,
  updateshipFailure,
  shipmentTypes,
  fetchDeviceSuccess,
  fetchDeviceFailure,
  fetchProfileSuccess,
  fetchProfileFailure,
  fetchAlertSuccess,
  fetchAlertFailure,
  bulkDeleteRequestSuccess,
  bulkDeleteRequestFailure,
  bulkCancelRequestSuccess,
  bulkCancelRequestFailure,
  updateSingleStateSuccess,
  updateSingleStateFailure,
  bulkEditRequestSuccess,
  bulkEditRequestFailure,
  fetchDeviceNameSuccess,
  fetchDeviceNameFailure,
  fetchAlertsContentSuccess,
  fetchAlertsContentFailure,
  updateBulkStateSuccess,
  updateBulkStateFailure,
  fetchLocationAlertsSuccess,
  fetchALLSuccess,
  fetchAllFailure
} from "../actions/shipment";
import { createMetricsFromResponse } from "../../../src/global/utility/Utils";
import { getRandomUUID } from "../../Token";
import {
  fetchShipment,
  fetchDeviceShipment,
  createShipment,
  deleteShipment,
  fetchShipAlertGroup,
  updateShipment,
  bulkUpdateShipment,
  fetchv1DeviceDetailsEndPoint,
  bulkDeleteShipment,
  fetchDeviceDetailsEndPoint,
  markAsCompletedShipmentEndPoint,
  bulkMarkAsCompletedShipmentEndPoint,
} from "../../configuration";
import { fetchLocationAlerts } from "../../../src/global/utility/Utils";
import { diffTime } from "../../global/utility/usDateFormatLast7Days";
import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import getAddressfromLatLong from "../../global/utility/getAddressfromLatLong";
import { v4 as uuidv4 } from "uuid";
dayjs.extend(utc);

function* fetchShipmentSaga() {
  if(!sessionStorage.getItem("accountId")) return;
  try {
    
    const { currentPage, pageSize, filters, query } = yield select((state) => ({
      currentPage: state.shipment.data.currentPage,
      pageSize: state.shipment.data.pageSize,
      filters: state.shipment.filters,
      query: state.shipment.data.query,
    }));
    
    const shipmentResponse = yield call(fetchShipments, currentPage, pageSize, filters, query);
  
    let shipments = [];
    if (
      shipmentResponse.data.hasOwnProperty("pagination") &&
      shipmentResponse.data.pagination.hasOwnProperty("shipments")
    ) {
      const currentDate = new Date();
      shipments = shipmentResponse.data.pagination.shipments.map((shipment) => {
        const updateAtDate = new Date(shipment.updatedat);
        const lastUpdated = diffTime(updateAtDate, currentDate);
        return {
          id: shipment.id,
          deviceid: shipment?.deviceid,
          shipmentid: shipment.shipmentid,
          startDateOriginal: shipment.startdate,
          status:
            shipment.shipmentstatus === null
              ? "No Alert"
              : shipment.shipmentstatus,
          shipmentName: shipment.shipmentname,
          state: shipment.shipmentstate,
          startDate: shipment.startdate,
          //  startDate: formatDate(shipment.startdate),
          // startDate: `${startDate.getFullYear()}-${(startDate.getMonth() + 1)
          //   .toString()
          //   .padStart(2, "0")}-${startDate
          //   .getDate()
          //   .toString()
          //   .padStart(2, "0")} at ${startDate
          //   .toLocaleTimeString("en-US", {
          //     timeZone: "America/New_York",
          //     hour12: true,
          //   })
          //   .padStart(11, "0")
          //   .toLowerCase()}`,
          lastUpdated: `${lastUpdated.diff} ${lastUpdated.unit} ago`,
          updateAt: shipment.updatedat,
          action: shipment.shipmentname,
          coordinates: [
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Origin"
            )?.longitude,
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Origin"
            )?.latitude,
          ],
          destinationCordinates: [
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Destination"
            )?.longitude,
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Destination"
            )?.latitude,
          ],
          currentlocation: shipment.currentlocation,
          devicetype: shipment.devicetype,
          oncompletion: shipment.oncompletion,
          productid: shipment.productid,
          productserialnumber: shipment.productserialnumber,
          trackingnumber: shipment.trackingnumber,
          ordernumber: shipment.ordernumber,
          customername: shipment.customername,
          ponumber: shipment.ponumber,
          deviceprofile: shipment?.deviceprofile,
          bledevice: shipment?.bledevice,
          devicename: shipment?.devicename,
          enableble: shipment?.enableble,
          updatedat: shipment?.updatedat,
          createdon: shipment?.createdon,
          shipmentstate: shipment?.shipmentstate,
        };
      });
    }

    yield put(
      fetchSuccess({
        query: shipmentResponse.query,
        count: shipmentResponse.data.pagination.totalRecords,
        shipments,
        map: {
          originCoordinates: getValidCoordinates(shipments),
          destinationCoordinates: [-73.961594, 40.86994],
        },
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(fetchFailure(error.message));
  }
}

function* fetchAllShipmentSaga() {
   if(!sessionStorage.getItem("accountId")) return;
  try {
    const { filters, query } = yield select((state) => ({
      filters: state.shipment.filters,
      query: state.shipment.data.query,
    }));
    
    const shipmentAllResponse = yield call(fetchShipments, undefined, undefined, filters, query);
  
    let allShipments = [];

    if (
      shipmentAllResponse.data.hasOwnProperty("pagination") &&
      shipmentAllResponse.data.pagination.hasOwnProperty("shipments")
    ) {
      const currentDate = new Date();
      allShipments = shipmentAllResponse.data.pagination.shipments.map((shipment) => {
        const updateAtDate = new Date(shipment.updatedat);
        const lastUpdated = diffTime(updateAtDate, currentDate);
        return {
          id: shipment.id,
          deviceid: shipment?.deviceid,
          shipmentid: shipment.shipmentid,
          startDateOriginal: shipment.startdate,
          status:
            shipment.shipmentstatus === null
              ? "No Alert"
              : shipment.shipmentstatus,
          shipmentName: shipment.shipmentname,
          state: shipment.shipmentstate,
          startDate: shipment.startdate,
          //  startDate: formatDate(shipment.startdate),
          // startDate: `${startDate.getFullYear()}-${(startDate.getMonth() + 1)
          //   .toString()
          //   .padStart(2, "0")}-${startDate
          //   .getDate()
          //   .toString()
          //   .padStart(2, "0")} at ${startDate
          //   .toLocaleTimeString("en-US", {
          //     timeZone: "America/New_York",
          //     hour12: true,
          //   })
          //   .padStart(11, "0")
          //   .toLowerCase()}`,
          lastUpdated: `${lastUpdated.diff} ${lastUpdated.unit} ago`,
          updateAt: shipment.updatedat,
          action: shipment.shipmentname,
          coordinates: [
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Origin"
            )?.longitude,
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Origin"
            )?.latitude,
          ],
          destinationCordinates: [
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Destination"
            )?.longitude,
            shipment?.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Destination"
            )?.latitude,
          ],
          currentlocation: shipment.currentlocation,
          devicetype: shipment.devicetype,
          oncompletion: shipment.oncompletion,
          productid: shipment.productid,
          productserialnumber: shipment.productserialnumber,
          trackingnumber: shipment.trackingnumber,
          ordernumber: shipment.ordernumber,
          customername: shipment.customername,
          ponumber: shipment.ponumber,
          deviceprofile: shipment?.deviceprofile,
          bledevice: shipment?.bledevice,
          devicename: shipment?.devicename,
          enableble: shipment?.enableble,
          updatedat: shipment?.updatedat,
          createdon: shipment?.createdon,
          shipmentstate: shipment?.shipmentstate,
        };
      });
    }

    yield put(
      fetchALLSuccess({
        allShipments,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(fetchAllFailure(error.message));
  }
}

function* fetchLocationAlertsSaga(req) {
  const { shipmentId, startTime, endTime, deviceId, originCoord } = req?.payload
  const shipmentData = yield select((state) => state.shipment.data.alertsContent.shipmentData);
  let currentlocation = {};
  let deviceFields = {};

  if (shipmentData) {
    currentlocation = shipmentData.currentlocation || {};
    deviceFields = shipmentData.fields || {};
  }
  const batteryPercentage = deviceFields?.battery
    ? Math.round((deviceFields.battery + Number.EPSILON) * 10) / 10
    : deviceFields?.battery === 0 ? 0 : "N/A";

  const temperatureValue = deviceFields?.temperature
    ? Math.round((((deviceFields.temperature * 9) / 5 + 32) + Number.EPSILON) * 10) / 10
    : "N/A";
  const resp = yield call(fetchLocationAlerts, deviceId, startTime, endTime, shipmentId);
  const mergedData = createMetricsFromResponse({ data: resp.data, originCoord, metrics: { battery: batteryPercentage, temperature: temperatureValue }, type: currentlocation?.type || "Unknown", alertType: req?.payload?.alertType });
  yield put(fetchLocationAlertsSuccess(mergedData));
}

const getValidCoordinates = (shipments) => {
  for (let i = 0; i < shipments.length; i++) {
    const coordinates = shipments[i].coordinates;
    if (
      coordinates &&
      coordinates[0] !== undefined &&
      coordinates[1] !== undefined
    ) {
      return coordinates;
    }
  }
  return null;
};
function filterQuery(filters, qry) {
  let query = {
    ...qry,
    shipmentid: undefined
  };

  if (filters.currentChangedFilterField) {
    if (
      filters.hasOwnProperty(filters.currentChangedFilterField) &&
      filters[filters.currentChangedFilterField].hasOwnProperty("sort") &&
      filters[filters.currentChangedFilterField].sort
    ) {
      switch (filters.currentChangedFilterField) {
        case "shipmentName":
          query = {
            ...query,
            $sort: [
              { field: "shipmentname", order: filters.shipmentName.sort },
            ],
          };
          break;
        case "startDate":
          query = {
            ...query,
            $sort: [{ field: "startdate", order: filters.startDate.sort }],
          };
          break;
        case "lastUpdated":
          query = {
            ...query,
            $sort: [{ field: "updatedat", order: filters.lastUpdated.sort }],
          };
          break;
        default:
          break;
      }
    }

    if (
      filters.hasOwnProperty(filters.currentChangedFilterField) &&
      filters[filters.currentChangedFilterField].hasOwnProperty("option") &&
      filters[filters.currentChangedFilterField].option
    ) {
      switch (filters.currentChangedFilterField) {
        case "status": {
          const q = filters[filters.currentChangedFilterField].option
            .filter((filterOpt) => filterOpt?.value === true)
            .map((option) => option.text);

          if (q.length > 0) {
            const shipmentstatus = q.map((qryRes) =>
              qryRes === "No Alert"
                ? "OK"
                : qryRes === "Critical"
                ? "ERROR"
                : qryRes?.toUpperCase()
            );
            query = {
              ...query,
              shipmentstatus,
            };
          } else {
            query = {
              ...query,
              shipmentstatus: undefined,
            };
          }
          break;
        }
        case "shipmentid": 
        query = {
            ...query,
            shipmentid: Array.isArray(filters[filters.currentChangedFilterField].option) && filters[filters.currentChangedFilterField].option.length > 0 ? filters[filters.currentChangedFilterField].option : undefined,
          };
        break;
        case "shipmentName":
          query = {
            ...query,
            shipmentname: filters[filters.currentChangedFilterField].option,
          };
          break;
        case "state": {
          const q = filters[filters.currentChangedFilterField].option
            .filter((filterOpt) => filterOpt?.value)
            .map((option) => option.text);

          if (q.length > 0) {
            query = {
              ...query,
              shipmentstate: q,
            };
          }
          break;
        }
        case "lastUpdated":
        case "startDate": {
          const isEmpty =
            Object.values(
              filters[filters.currentChangedFilterField].option
            ).map((opt) => opt).length === 0;

          if (!isEmpty) {
            query = {
              ...query,
              ...filters[filters.currentChangedFilterField].option,
            };
          }
          break;
        }
        default:
          break;
      }
    }
  }
  
  return query;
}

async function fetchShipments(currentPage, pageSize, filters, query) {
  let filteredQuery = null;
  if(filters && query){
    filteredQuery = filterQuery(filters, query);
  }
  const response = await fetch(fetchShipment(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      limit: pageSize,
      page: currentPage,
      filter: filteredQuery || undefined,
    }),
  });

  if (!response.ok) return [];

  return {
    query: filteredQuery,
    data: await response.json(),
  };
}

function* deleteShipmentSaga() {
  try {
    const shipmentId = yield select(
      (state) => state.shipment.ui.delete.deletedField.record.shipmentid
    );

    if (!shipmentId) {
      return;
    }

    yield call(deleteShipments, shipmentId);

    yield put(singleDeleteRequestSuccess("Shipment Deleted Successfully"));
  } catch (error) {
    console.log("error", error);
    yield put(singleDeleteRequestFailure(error.message));
  }
}

function* bulkDeleteShipmentSaga() {
  try {
    const shipmentIds = yield select((state) =>
      Array.isArray(state.shipment.ui.selectedFields) &&
      state.shipment.ui.selectedFields.length > 0
        ? state.shipment.ui.selectedFields.map(
            (selectedField) => selectedField.record.shipmentid
          )
        : []
    );

    if (shipmentIds.length < 1) {
      return;
    }

    yield call(bulkDeleteShipments, shipmentIds);

    yield put(
      bulkDeleteRequestSuccess("Selected Shipments Deleted Successfully")
    );
  } catch (error) {
    console.log("error", error);
    yield put(bulkDeleteRequestFailure(error.message));
  }
}

async function deleteShipments(shipmentid) {
  const response = await fetch(deleteShipment(), {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      shipmentid,
    }),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.details);
  }

  return response.json();
}
function* cancelShipmentSaga() {
  try {
    const shipmentId = yield select(
      (state) => state.shipment.ui.cancel.cancelField.record.shipmentid
    );
    if (!shipmentId) {
      return;
    }

    yield call(cancelShipments, shipmentId);

    yield put(singleCancelRequestSuccess("Shipment Cancel Successfully"));
  } catch (error) {
    console.log("error", error);
    yield put(singleCancelRequestFailure(error.message));
  }
}

function* bulkCancelShipmentSaga() {
  try {
    const shipmentIds = yield select((state) =>
      Array.isArray(state.shipment.ui.selectedFields) &&
      state.shipment.ui.selectedFields.length > 0
        ? state.shipment.ui.selectedFields.map(
            (selectedField) => selectedField.record.shipmentid
          )
        : []
    );

    if (shipmentIds.length < 1) {
      return;
    }

    yield call(bulkCancelShipments, shipmentIds);

    yield put(
      bulkCancelRequestSuccess("Selected Shipments Cancelled Successfully")
    );
  } catch (error) {
    console.log("error", error);
    yield put(bulkCancelRequestFailure(error.message));
  }
}

async function cancelShipments(shipmentid) {
  const response = await fetch(deleteShipment(), {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      shipmentid,
      shipmentstate: "Cancelled",
    }),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.details);
  }

  return response.json();
}

function* deviceDetailsShipmentSaga(action) {
  try {
    const createResponse = yield call(fetchDeviceDetails, action.payload);
    yield put(deviceDetailsRequest({ selectedDeviceDetails: createResponse }));
  } catch (error) {
    yield put(createFailure(error.message));
  }
}

async function fetchDeviceDetails(deviceId) {
  const response = await fetch(fetchDeviceDetailsEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      deviceId: deviceId.payload.deviceid,
    }),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.details);
  }

  return response.json();
}

async function bulkDeleteShipments(shipmentids = []) {
  const response = await fetch(bulkDeleteShipment(), {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      shipmentids,
    }),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.details);
  }

  return response.json();
}
async function bulkCancelShipments(shipmentids = []) {
  const response = await fetch(bulkDeleteShipment(), {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      shipmentids,
      shipmentstate: "Cancelled",
    }),
  });

  if (!response.ok) {
    const errResp = await response.json();
    throw new Error(errResp.details);
  }

  return response.json();
}

function* downloadShipmentSaga() {
  try {
    const count = yield select((state) => state.shipment.data.count);
    let response;
    if (count > 500) {
      let totalPages = 1;
      if (count % 500 === 0) {
        totalPages = count / 500;
      } else {
        totalPages = Math.floor(count / 500) + 1;
      }

      response = yield all(
        [...Array(totalPages)].map((v, i) => call(apiDownload, i + 1))
      );
    } else {
      response = yield call(apiDownload, 1);
    }

    JSONToCSVDownload(
      CSVFormat(response?.pagination?.shipments),
      "shipments_download.csv"
    );
    yield put(downloadSuccess());
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}

const CSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    id: json.id,
    currentlocation: json.currentlocation,
    customername: json.customername,
    destination: json.destination,
    deviceid: json.deviceid,
    deviceprofile: json.deviceprofile,
    devicetype: json.devicetype,
    isavailable: json.isavailable,
    milestones: json.milestones,
    oncompletion: json.oncompletion,
    ordernumber: json.ordernumber,
    origin: json.origin,
    ponumber: json.ponumber,
    productid: json.productid,
    productserialnumber: json.productserialnumber,
    shipmentid: json.shipmentid,
    shipmentname: json.shipmentname,
    shipmentstate: json.shipmentstate,
    shipmentstatus: json.shipmentstatus,
    startdate: json.startdate,
    trackingnumber: json.trackingnumber,
    updatedat: json.updatedat,
  }));
};

async function apiDownload(currentPage) {
  const response = await fetch(fetchShipment(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      limit: 500,
      page: currentPage,
    }),
  });

  if (!response.ok) return [];

  return response.json();
}

function* createShipmentSaga(action) {
  try {
    yield call(createshipment, action.payload);
    yield put(createSuccess("Shipment Created Successfully"));
    // yield put(createSuccess({ ...createResponse }));
  } catch (error) {
    console.log("Error", error);
    yield put(createFailure(error.message));
  }
}

async function createshipment(value) {
  const activeSession = JSON.parse(sessionStorage.getItem("activeSession"));
  let output = {};
  let bledevice = [];
  if (Array.isArray(value)) {
    let val = value[0]?.editField;
    let ble = value[0]?.ble;
    output = {
      accountName: sessionStorage.getItem("accountId"),
      shipmentname: val?.shipmentName?.value,
      devicetype: val?.devicetype?.value,
      deviceid: val?.deviceId?.value,
      startdate: val?.startDate?.value,
      enableble: val?.isBLEEnabled?.value,
      oncompletion: val?.onShipmentCompletion?.value,
      productid: val?.productId?.value,
      createdby: `${activeSession?.userName}`,
      deviceprofile: val?.selectProfile?.value?.id
        ? {
            id: val?.selectProfile?.value?.id,
            name: val?.selectProfile?.value?.name !==undefined? val?.selectProfile?.value?.name: val?.selectProfile?.value?.profilename,
            profilename:val?.selectProfile?.value?.name !==undefined? val?.selectProfile?.value?.name: val?.selectProfile?.value?.profilename,
            locations: val?.selectProfile?.value?.locations,
          }
        : null,
      productserialnumber: val?.productSerialNumber?.value,
      trackingnumber: val?.trackingNumber?.value,
      customername: val?.customerName?.value,
      ponumber: val?.poNumber?.value,
      ordernumber: val?.orderNumber?.value,
    };
    if (val?.isBLEEnabled?.value === "yes" && Array.isArray(ble)) {
      bledevice = ble.map((item) => ({
        id: item?.uid,
        name: item?.name,
        profile: item?.deviceProfile,
        serial: item?.serial,
      }));
    } else {
      bledevice = [];
    }
  } else if (typeof value === "object" && value !== null) {
    output = {
      accountName: sessionStorage.getItem("accountId"),
      shipmentname: value?.shipmentname,
      devicetype: value?.devicetype,
      deviceid: value?.deviceid,
      devicename: value?.devicename,
      startdate: value?.startdate,
      oncompletion: value?.oncompletion,
      deviceprofile: value?.deviceprofile,
      productid: value?.productid,
      enableble: value?.enabledevice,
      createdby: `${activeSession?.userName}`,
      productserialnumber: value?.productserialnumber,
      trackingnumber: value?.trackingnumber,
      customername: value?.customername,
      ponumber: value?.ponumber,
      ordernumber: value?.ordernumber,
    };
    if (value?.enabledevice === "yes" && Array.isArray(value?.ble)) {
      bledevice = value.ble.map((item) => ({
        id: item?.uid,
        name: item?.name,
        profile: item?.deviceProfile,
        serial: item?.serial,
      }));
    } else {
      bledevice = [];
    }
  }
  const originLoc = output?.deviceprofile?.locations?.filter(
    (loc) => loc?.locationtype === "Origin"
  );
  if (originLoc?.length > 0) {
    output.currentlocation = {
      lat: originLoc[0]?.latitude,
      long: originLoc[0]?.longitude,
      name: originLoc[0]?.name,
    };
  }

  output.bledevice = bledevice.length > 0 ? bledevice : "";
  try {
    const response = await fetch(createShipment(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        "VZ-M2M-Token": getRandomUUID(),
        "X-Transaction-Id": uuidv4(),
      },
      method: "POST",
      body: JSON.stringify(output),
    });

    if (!response.ok) {
      throw new Error("Something went wrong!!");
    }

    return response.json();
  } catch (error) {
    console.error("Error creating shipment:", error);
    throw error;
  }
}
function* updateShipmentSaga(action) {
  try {
    // const updateResponse = yield call(updateshipment(action?.payload),action.payload);
    yield call(updateshipment, action.payload);
    yield put(updateshipSuccess("Shipment Updated Successfully"));
    // yield put(updateshipSuccess({ ...updateResponse }));
  } catch (error) {
    yield put(updateshipFailure(error.message));
  }
}
async function updateshipment(value) {
  const activeSession = JSON.parse(sessionStorage.getItem("activeSession"));
  let val = value?.editField;
  let ble = value?.ble;
  let oldRecord = value?.editRecord?.record;
  try {
    let requestBody = {
      accountName: sessionStorage.getItem("accountId"),
      shipmentid: val?.shipmentid?.value,
      shipmentname: val?.shipmentName?.value,
      devicetype: val?.devicetype?.value,
      deviceid: val?.deviceId?.value,
      devicename: val?.deviceName?.value || oldRecord?.devicename,
      startdate: val?.startDate?.value,
      createdby: `${activeSession?.userName}`,
      enableble: val?.isBLEEnabled?.value,
      oncompletion: val?.onShipmentCompletion?.value,
      productid: val?.productId?.value,
      deviceprofile: val?.selectProfile?.value?.id
        ? {
            id: val?.selectProfile?.value?.id,
            profilename: val?.selectProfile?.value?.name !==undefined? val?.selectProfile?.value?.name : val?.selectProfile?.value?.profilename,
            locations: val?.selectProfile?.value?.locations,
          }
        : null,
      productserialnumber: val?.productSerialNumber?.value,
      trackingnumber: val?.trackingNumber?.value,
      customername: val?.customerName?.value,
      ponumber: val?.poNumber?.value,
      ordernumber: val?.orderNumber?.value,
      bledevice:
        val?.isBLEEnabled?.value === "yes"
          ? ble?.map((item) => ({
              id: item?.uid,
              name: item?.name,
              profile: item?.deviceProfile,
              serial: item?.serial,
            }))
          : [],
    };
    if (val?.deviceId?.value !== oldRecord?.deviceid) {
      requestBody.olddeviceid = oldRecord?.deviceid;
    }

    //uncomment it if we want to set origin as current location when we edit the shipment
    const originLoc = requestBody?.deviceprofile?.locations?.filter(
      (loc) => loc?.locationtype === "Origin"
    );
    if (originLoc.length > 0) {
      requestBody.currentlocation = {
        lat: originLoc[0]?.latitude,
        long: originLoc[0]?.longitude,
        name: originLoc[0]?.name,
      };
    }

    const response = await fetch(updateShipment(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
        "X-Transaction-Id": uuidv4(),
      },
      method: "PATCH",
      body: JSON.stringify({
        ...requestBody,
      }),
    });
    if (!response?.ok) {
      throw new Error("Something went wrong!!");
    }
    return response?.json();
  } catch (error) {
    console.error("Error creating shipment:", error);
    throw error;
  }
}
function* fetchShipDeviceSaga() {
  try {
    const response = yield call(fetchShipDeviceAPI);
    yield put(fetchDeviceSuccess({ deviceType: response }));
  } catch (error) {
    yield put(fetchDeviceFailure(error.message));
  }
}
async function fetchShipDeviceAPI() {
  try {
    let body = {
      accountName: sessionStorage.getItem("accountId"),
    };
    const response = await fetch(
      fetchDeviceShipment() + "/devices/getdevicetypes",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    return response.json();
  } catch (error) {
    return [];
  }
}

function* fetchShipDeviceNameSaga() {
  try {
    const response = yield call(fetchShipDeviceNameAPI);
    yield put(fetchDeviceNameSuccess({ deviceName: response }));
  } catch (error) {
    yield put(fetchDeviceNameFailure(error.message));
  }
}
async function fetchShipDeviceNameAPI(deviceid) {
  try {
    const response = await fetch(fetchv1DeviceDetailsEndPoint(deviceid), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        filter: {
          $sort: [
            {
              field: "createdon",
              order: "desc",
            },
          ],
        },
        resourceIdentifier: {deviceid},
        // $limitnumber: 500,
        // $pagenumber: 0,
        //  $filter: "($/customdata/isAvailable eq true)",
      }),
    });
    return response.json();
  } catch (error) {
    return [];
  }
}

function* fetchShipProfileSaga(filters={}) {

  try {
    const response = yield call(fetchShipProfileAPI, filters?.payload);
    yield put(fetchProfileSuccess({ shipProfile: response?.deviceprofiles }));
  } catch (error) {
    yield put(fetchProfileFailure(error.message));
  }
}
async function fetchShipProfileAPI(filters={}) {
  try {
    let body = {
      accountName: sessionStorage.getItem("accountId"),
      //limit: 500,
    };
    if(filters?.selection){
      body = {...body, filter: {'$selection' : filters?.selection}}
    }
    const response = await fetch(
      fetchDeviceShipment() + "/devices/getdeviceprofiles",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    return response.json();
  } catch (error) {
    return [];
  }
}
function* fetchShipAlertSaga() {
  try {
    const response = yield call(fetchShipAlertAPI);
    yield put(fetchAlertSuccess({ alertGroup: response }));
  } catch (error) {
    yield put(fetchAlertFailure(error.message));
  }
}
async function fetchShipAlertAPI() {
  try {
    const response = await fetch(fetchShipAlertGroup(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
      }),
    });
    return response.json();
  } catch (error) {
    return [];
  }
}

function* singleUpdateShipmentStateSaga() {
  try {
    const { selectedCurrentData } = yield select((state) => ({
      selectedCurrentData: state.shipment.ui.edit.currentUpdateState.selected,
    }));

    if (Object.keys(selectedCurrentData).length < 1) {
      return;
    }

    yield call(singleUpdateShipmentStatus, {
      billingaccountid: sessionStorage.getItem("accountId"),
      manual: true,
      deviceid: selectedCurrentData?.deviceid,
      fields: {
        location: selectedCurrentData?.location[0] || {},
      },
    });

    yield put(
      updateSingleStateSuccess(
        `${selectedCurrentData?.shipmentName} state updated successfully!!`
      )
    );
  } catch (error) {
    console.log("error", error);
    yield put(updateSingleStateFailure(error.message));
  }
}

async function singleUpdateShipmentStatus(val) {
  const response = await fetch(markAsCompletedShipmentEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(val),
  });

  if (!response.ok) {
    const rsp = await response.json();
    throw new Error(rsp?.error);
  }

  return response.json();
}

function* bulkEditShipmentSaga() {
  try {
    const { shipmentIds, formData } = yield select((state) => ({
      shipmentIds:
        Array.isArray(state.shipment.ui.selectedFields) &&
        state.shipment.ui.selectedFields.length > 0
          ? state.shipment.ui.selectedFields.map(
              (selectedField) => selectedField?.record?.shipmentid
            )
          : [],
      formData: state.shipment.ui.edit.bulkEditFormData,
    }));

    if (shipmentIds.length < 1) {
      return;
    }

    yield call(bulkEditShipments, shipmentIds, formData);

    yield put(bulkEditRequestSuccess("Selected Shipments Edited Successfully"));
  } catch (error) {
    console.log("error", error);
    yield put(bulkEditRequestFailure(error.message));
  }
}

async function bulkEditShipments(shipmentIds = [], formData = {}) {
  const response = await fetch(bulkUpdateShipment(), {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "X-Transaction-Id": uuidv4(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      updates: shipmentIds.map((shipmentId) => {
        if (formData?.state === "Scheduled") {
          return {
            shipmentid: shipmentId,
            startdate: formData?.startDate,
            deviceprofile: formData?.profile,
            oncompletion: formData?.onShipmentCompletion,
          };
        }
        return {
          shipmentid: shipmentId,
          deviceprofile: formData?.profile,
          oncompletion: formData?.onShipmentCompletion,
        };
      }),
    }),
  });

  if (!response.ok) {
    const rsp = await response.json();
    throw new Error(rsp?.error);
  }

  return response.json();
}

async function fetchDeviceFields(deviceId) {
  if (!deviceId) {
    return { fields: {} };
  }

  try {
    const response = await fetch(fetchDeviceDetailsEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        deviceId: deviceId,
        accountName: sessionStorage.getItem("accountId"),
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (!data.fields) {
      data.fields = {};
    }

    return data;
  } catch (error) {
    console.error("Error in fetchDeviceFields:", error);
    return { fields: {} };
  }
}

function* fetchAlertsContentSaga(action) {
  try {
    const { deviceid, shipmentid } = action.payload;
    if (deviceid || shipmentid) {
      // For specific device or shipment
      const shipmentData = yield call(fetchShipmentData, {
        deviceid,
        shipmentid,
      });

      let currentaddress = "N/A";
      if (
        shipmentData &&
        Object.hasOwn(shipmentData, "currentlocation") &&
        shipmentData?.currentlocation?.lat !== undefined &&
        shipmentData?.currentlocation?.long !== undefined &&
        Object.hasOwn(shipmentData?.currentlocation, "lat") &&
        Object.hasOwn(shipmentData?.currentlocation, "long")
      ) {
        currentaddress = yield call(
          getAddressfromLatLong,
          shipmentData?.currentlocation?.lat,
          shipmentData?.currentlocation?.long
        );
      }
      const finalShipmentData = { ...shipmentData, currentaddress };

      yield put(fetchAlertsContentSuccess({ shipmentData: finalShipmentData }));
    } else {
      const response = yield call(fetchShipments, 1, 10, {}, {});

      if (response.data?.pagination?.shipments?.length > 0) {
        const shipmentData = response.data.pagination.shipments[0];

        const deviceData = yield call(fetchShipDeviceNameAPI, shipmentData.deviceid);

        let currentaddress = "N/A";
        if (
          shipmentData &&
          Object.hasOwn(shipmentData, "currentlocation") &&
          Object.hasOwn(shipmentData.currentlocation, "lat") &&
          Object.hasOwn(shipmentData.currentlocation, "long")
        ) {
          currentaddress = yield call(
            getAddressfromLatLong,
            shipmentData.currentlocation.lat,
            shipmentData.currentlocation.long
          );
        }

        const processedData = {
          ...shipmentData,
          currentaddress,
          devicetype: shipmentData.devicetype,
          oncompletion: shipmentData.oncompletion,
          deviceid: shipmentData.deviceid,
          origin:
            shipmentData.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Origin"
            )?.name || "N/A",
          destination:
            shipmentData.deviceprofile?.locations?.find(
              (loc) => loc.locationtype === "Destination"
            )?.name || "N/A",
          fields: deviceData?.fields || {},
        };
        yield put(
          fetchAlertsContentSuccess({
            shipmentData: processedData,
          })
        );
      } else {
        yield put(fetchAlertsContentFailure("No shipments found"));
      }
    }
    if (action?.payload?.onComplete) {
      action.payload.onComplete();
    }
  } catch (error) {
    console.error("Error fetching alerts content:", error);
    yield put(fetchAlertsContentFailure(error.message));
  }
}

async function fetchShipmentData({ deviceid, shipmentid }) {
  const response = await fetch(fetchShipment(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();

  if (data?.pagination?.shipments?.length > 0) {
    let selectedShipment = null;

    if (shipmentid) {
      selectedShipment = data.pagination.shipments.find(
        (s) => s.shipmentid === shipmentid
      );
    }

    if (!selectedShipment && deviceid) {
      selectedShipment = data.pagination.shipments.find(
        (s) => s.deviceid === deviceid
      );
    }

    if (!selectedShipment) {
      selectedShipment = data.pagination.shipments[0];
    }

    if (selectedShipment) {
      const deviceData = await fetchShipDeviceNameAPI(selectedShipment.deviceid);
      const result = {
        ...selectedShipment,
        devicetype: selectedShipment.devicetype,
        oncompletion: selectedShipment.oncompletion,
        deviceid: selectedShipment.deviceid,
        origin:
          selectedShipment.deviceprofile?.locations?.find(
            (loc) => loc.locationtype === "Origin"
          )?.name || "N/A",
        destination:
          selectedShipment.deviceprofile?.locations?.find(
            (loc) => loc.locationtype === "Destination"
          )?.name || "N/A",
        fields: deviceData?.devices?.[0]?.fields || {},
      };
      return result;
    }
  }

  throw new Error("No shipment data found");
}

function* bulkUpdateShipmentStateSaga() {
  try {
    const { shipments } = yield select((state) => ({
      shipments:
        Array.isArray(state.shipment.ui.selectedFields) &&
        state.shipment.ui.selectedFields.length > 0
          ? state.shipment.ui.selectedFields.map((selectedField) => {
              const locations = selectedField?.record?.deviceprofile?.locations
                ?.filter((location) => location?.locationtype === "Destination")
                ?.map((location) => ({
                  latitude: location?.latitude,
                  longitude: location?.longitude,
                }));

              return {
                billingaccountid: sessionStorage.getItem("accountId"),
                deviceid: selectedField?.record?.deviceid,
                manual: true,
                fields: {
                  location: locations?.length > 0 ? locations[0] : [],
                },
              };
            })
          : [],
    }));

    if (Array.isArray(shipments) && shipments.length < 1) {
      return;
    }

    yield call(bulkUpdateShipmentStatus, {
      shipments: Array.isArray(shipments)
        ? shipments?.map((shipment) => shipment)
        : [],
    });

    yield put(
      updateBulkStateSuccess(
        `${shipments?.length} state updated successfully!!`
      )
    );
  } catch (error) {
    console.log("error", error);
    yield put(updateBulkStateFailure(error.message));
  }
}

async function bulkUpdateShipmentStatus(val) {
  const response = await fetch(bulkMarkAsCompletedShipmentEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(val),
  });

  if (!response.ok) {
    const rsp = await response.json();
    throw new Error(rsp?.error);
  }

  return response.json();
}

export function* FetchShipmentSaga() {
  yield takeLatest(shipmentTypes.FETCH_REQUEST, fetchShipmentSaga);
}

export function* DeviceDetailsShipmentSaga() {
  yield takeLatest(
    shipmentTypes.FETCH_DEVICE_DETAILS,
    deviceDetailsShipmentSaga
  );
}

export function* FetchShipDeviceSaga() {
  yield takeLatest(shipmentTypes.FETCH_DEVICE_REQUEST, fetchShipDeviceSaga);
}
export function* FetchLocationAlertsSaga() {
  yield takeLatest(
    shipmentTypes.FETCH_LOCATION_ALERTS,
    fetchLocationAlertsSaga
  );
}
export function* FetchShipProfileSaga() {
  yield takeLatest(shipmentTypes.FETCH_PROFILE_REQUEST, fetchShipProfileSaga);
}
export function* FetchShipAlertSaga() {
  yield takeLatest(shipmentTypes.FETCH_ALERT_REQUEST, fetchShipAlertSaga);
}
export function* DownloadShipmentSaga() {
  yield takeLatest(shipmentTypes.DOWNLOAD_REQUEST, downloadShipmentSaga);
}

export function* CreateShipmentSaga() {
  yield takeLatest(shipmentTypes.CREATE_REQUEST, createShipmentSaga);
}
export function* UpdateShipmentSaga() {
  yield takeLatest(shipmentTypes.UPDATE_SHIP_REQUEST, updateShipmentSaga);
}

export function* DeleteShipmentSaga() {
  yield takeLatest(shipmentTypes.SINGLE_DELETE_REQUEST, deleteShipmentSaga);
}

export function* BulkDeleteShipmentSaga() {
  yield takeLatest(shipmentTypes.BULK_DELETE_REQUEST, bulkDeleteShipmentSaga);
}
export function* CancelShipmentSaga() {
  yield takeLatest(shipmentTypes.SINGLE_CANCEL_REQUEST, cancelShipmentSaga);
}

export function* BulkCancelShipmentSaga() {
  yield takeLatest(shipmentTypes.BULK_CANCEL_REQUEST, bulkCancelShipmentSaga);
}
export function* FetchShipDeviceNameSaga() {
  yield takeLatest(
    shipmentTypes.FETCH_DEVICE_NAME_REQUEST,
    fetchShipDeviceNameSaga
  );
}

export function* SingleUpdateShipmentStateSaga() {
  yield takeLatest(
    shipmentTypes.SINGLE_UPDATE_STATE_REQUEST,
    singleUpdateShipmentStateSaga
  );
}

export function* BulkUpdateShipmentStateSaga() {
  yield takeLatest(
    shipmentTypes.BULK_UPDATE_STATE_REQUEST,
    bulkUpdateShipmentStateSaga
  );
}

export function* BulkEditShipmentSaga() {
  yield takeLatest(shipmentTypes.BULK_EDIT_REQUEST, bulkEditShipmentSaga);
}

export function* FetchAlertsContentSaga() {
  yield takeLatest(
    shipmentTypes.FETCH_ALERTS_CONTENT_REQUEST,
    fetchAlertsContentSaga
  );
}

export function* FetchAllShipmentSaga() {
  yield takeLatest(shipmentTypes.FETCH_REQUEST, fetchAllShipmentSaga);
}